/**
 * Custom event names for MXP365 dialog communication
 */
export const MXP365_EVENTS = {
  OPEN: 'mxp365:open',
  CLOSE: 'mxp365:close',
} as const;

import type PrismAPI from '@modules/prism-client/types/prism-types';

/**
 * Event detail types for MXP365 custom events
 */
export type Mxp365OpenEventDetail = {
  title: string;
  path: string; // Clean path without /mxp365tiles prefix (e.g., "/favorites")
  token: string;
  queryParams?: Record<string, string>; // Additional query parameters
  telemetry?: PrismAPI.TelemetryInstruction[];
};

export type Mxp365CloseEventDetail = void;

/**
 * Custom event type definitions
 */
export type Mxp365OpenEvent = CustomEvent<Mxp365OpenEventDetail>;
export type Mxp365CloseEvent = CustomEvent<Mxp365CloseEventDetail>;

/**
 * Factory function to create an MXP365 open event
 */
export const createMxp365OpenEvent = (params: {
  path: string;
  title: string;
  token?: string;
  queryParams?: Record<string, string>;
  telemetry?: PrismAPI.TelemetryInstruction[];
}): CustomEvent<Mxp365OpenEventDetail> => {
  return new CustomEvent(MXP365_EVENTS.OPEN, {
    detail: {
      path: params.path,
      title: params.title,
      token: params.token || '',
      queryParams: params.queryParams,
      telemetry: params.telemetry,
    },
  });
};
